export default "__VITE_ASSET__ufcTd2p$__"